const originalFetch = window.fetch;
const MAX_ENTRIES = 100;

/* *** *** *** **
 * property window.zebInsightsRequestHistory is used by zebdsh.appframe
 * *** *** *** */

function addRequestHistoryEntry(
  resourceParam,
  optionsParam,
  timeStart,
  response
) {
  const entries = window.zebInsightsRequestHistory;
  if (entries != null) {
    const newEntry = {
      url: getUrlFromParam(resourceParam),
      traceparent: getTraceparentFromParams(resourceParam, optionsParam),
      status: (response && response.status) || null,
      timeStart: timeStart,
      timeEnd: Date.now(),
    };
    entries.unshift(newEntry);
    if (entries.length > MAX_ENTRIES) {
      entries.pop();
    }
  }
}

function getUrlFromParam(resourceParam) {
  if (resourceParam instanceof Request) {
    return resourceParam.url;
  } else if (resourceParam != null) {
    return String(resourceParam);
  } else {
    return null;
  }
}

function getTraceparentFromParams(resourceParam, optionsParam) {
  const traceparentFromOptions = getTraceparentFromParam(optionsParam);
  if (traceparentFromOptions != null) {
    return traceparentFromOptions;
  } else {
    return getTraceparentFromParam(resourceParam);
  }
}

function getTraceparentFromParam(param) {
  return (
    (param &&
      param.headers &&
      param.headers.get &&
      param.headers.get("traceparent")) ||
    (param && param.headers && param.headers.traceparent) ||
    null
  );
}

export function initCollector() {
  window.zebInsightsRequestHistory = [];
  window.fetch = async (...args) => {
    let [resourceParam, optionsParam] = args;
    const timeStart = Date.now();
    const response = await originalFetch(resourceParam, optionsParam);
    addRequestHistoryEntry(resourceParam, optionsParam, timeStart, response);
    return response;
  };
}
